import Post from 'components/Post';
import {contentItemProps} from "utils/propTypes";
import {getServerSidePropsForContent} from "utils/getServerSideProps";

function WorkItem ({ currentPost }) {
  if (!currentPost) {
    return <p>Post not found.</p>;
  }

  return <Post type="work" currentPost={currentPost} />;
}

export const getServerSideProps = getServerSidePropsForContent

WorkItem.propTypes = contentItemProps

export default WorkItem;